import { useHistory } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
// actions
import { showEnvAuditNavigation } from "../../../store/actions";

const initialServices = [
  { name: "Request for Authorization for Use of Single-use Plastics", key: "auth_plastics" },
  { name: "Request for Environmental Audit", key: "env_audit" },
];

const EnvComplianceDashboard = (props) => {
  const history = useHistory();
  const [services, setServices] = useState(initialServices);

  useEffect(() => {
    // props.showEnvAuditNavigation("SHOW_ENV_AUDIT_NAVIGATION");
  }, []);

  const handleServiceClick = (key) => {
    // console.log("Clicked on service:", key);
    if (key == "env_audit") {
        props.showEnvAuditNavigation("SHOW_ENV_AUDIT_NAVIGATION");
    } else {
        props.showEnvAuditNavigation("HIDE_ENV_AUDIT_NAVIGATION");
    }
    
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Environmental Audit Menu | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">Division of Environmental Compliance & Enforcement Dashboard</h6>
              </Col>
            </Row>
          </div>
          <Row>
            {services.map((service) => (
              <Col md={6} lg={4} key={service.key}>
                <Card
                  className="service-card"
                  onClick={() => handleServiceClick(service.key)}
                  style={{
                    cursor: "pointer",
                    transition: "transform 0.2s ease-in-out",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  <CardBody>
                    <h5 className="text-center">{service.name}</h5>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

EnvComplianceDashboard.propTypes = {
  showEnvAuditNavigation: PropTypes.func,
};

const mapStateToProps = (state) => ({
  showEnvAuditNav: state.Layout.show_env_audit_navigation,
});

export default withRouter(
  connect(mapStateToProps, { showEnvAuditNavigation })(EnvComplianceDashboard)
);
